export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      email
      firstName
      lastName
      isActive
      workspaces {
        items {
          workspace {
            id
            name
            organizationId
          }
        }
      }
      organizations {
        items {
          id
          organizationId
        }
      }
    }
  }
`;
export const listUsersByEmail = /* GraphQL */ `
  query ListUsersByEmail(
    $email: String
    $id: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsersByEmail(
      email: $email
      id: $id
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        email
        firstName
        lastName
        isActive
      }
      nextToken
    }
  }
`;
export const getOrganization = /* GraphQL */ `
  query GetOrganization($id: ID!) {
    getOrganization(id: $id) {
      id
      name
      color
      workspaceLimit
      connectionLimit
      warehouseRetention
      timezone
      maintenanceWindow
      slug
      users {
        items {
          user {
            id
            email
            firstName
            lastName
            isActive
            workspaces {
              items {
                workspace {
                  id
                  name
                  organizationId
                }
              }
            }
            organizations {
              items {
                id
                organizationId
              }
            }
          }
        }
        nextToken
      }
      cloudResourceId
      wholeSourceConfig
      wholeSourceConfigVersion
      terraformConfig
      terraformConfigVersion
      workspaces {
        items {
          id
          name
        }
      }
    }
  }
`;
export const listOrganizationsBySlug = /* GraphQL */ `
  query ListOrganizationsBySlug(
    $slug: String
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrganizationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrganizationsBySlug(
      slug: $slug
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        color
        workspaceLimit
        warehouseRetention
        timezone
        maintenanceWindow
        slug
        users {
          items {
            user {
              id
              email
              firstName
              lastName
              isActive
              workspaces {
                items {
                  workspace {
                    id
                    name
                    organizationId
                  }
                }
              }
              organizations {
                items {
                  id
                  organizationId
                }
              }
            }
          }
          nextToken
        }
        cloudResourceId
        wholeSourceConfig
        wholeSourceConfigVersion
        terraformConfig
        terraformConfigVersion
        workspaces {
          items {
            id
            name
          }
        }
      }
      nextToken
    }
  }
`;
export const listOrganizationUsersByOrganization = /* GraphQL */ `
  query ListOrganizationUsersByOrganization(
    $organizationId: ID
    $userId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrganizationUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrganizationUsersByOrganization(
      organizationId: $organizationId
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        isOrgAdmin
      }
      nextToken
    }
  }
`;
export const listOrganizationUsersByUser = /* GraphQL */ `
  query ListOrganizationUsersByUser(
    $userId: ID
    $organizationId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrganizationUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrganizationUsersByUser(
      userId: $userId
      organizationId: $organizationId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        organizationId
        hasWarehouseCredentials
      }
      nextToken
    }
  }
`;
export const getOrganizationFivetran = /* GraphQL */ `
  query GetOrganizationFivetran($id: ID!) {
    getOrganizationFivetran(id: $id) {
      id
      groupId
    }
  }
`;
export const getOrganizationChargebee = /* GraphQL */ `
  query GetOrganizationChargebee($id: ID!) {
    getOrganizationChargebee(id: $id) {
      id
      subscriptionId
      allowance
      billingCycleDate
      usageAddons
      createdAt
      updatedAt
    }
  }
`;
export const listOrganizationChargebees = /* GraphQL */ `
  query ListOrganizationChargebees(
    $filter: ModelOrganizationChargebeeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrganizationChargebees(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        subscriptionId
        allowance
        billingCycleDate
        usageAddons
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listOrganizationDPUsByOrganization = /* GraphQL */ `
  query ListOrganizationDPUsByOrganization(
    $organizationId: ID
    $date: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrganizationDPUFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrganizationDPUsByOrganization(
      organizationId: $organizationId
      date: $date
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        organizationId
        date
        dpu
        storage
        warehouseStorageMb
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getOrganizationAIContext = /* GraphQL */ `
  query GetOrganizationAIContext($id: ID!) {
    getOrganizationAIContext(id: $id) {
      id
      orgId
      industry
      description
      industries
      business
      customers
      mission
      differentiators
      objectives
      companyType
      employeeCount
      foundedDate
      markets
      productsServices
      website
      logoS3Key
      iconS3Key
      logoDarkS3Key
      iconDarkS3Key
      primaryColor
      secondaryColor
      accentColor
      backgroundColor
      surfaceColor
      borderColor
      textColor
      mutedTextColor
      successColor
      warningColor
      errorColor
      additionalInstructions
      defaultIdentityPackId
      updatedBy
      themes
      createdAt
      updatedAt
    }
  }
`;
export const listOrganizationAIContextsByOrgId = /* GraphQL */ `
  query ListOrganizationAIContextsByOrgId(
    $orgId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelOrganizationAIContextFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrganizationAIContextsByOrgId(
      orgId: $orgId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        orgId
        industry
        description
        industries
        business
        customers
        mission
        differentiators
        objectives
        companyType
        employeeCount
        foundedDate
        markets
        productsServices
        website
        logoS3Key
        iconS3Key
        logoDarkS3Key
        iconDarkS3Key
        primaryColor
        secondaryColor
        accentColor
        backgroundColor
        surfaceColor
        borderColor
        textColor
        mutedTextColor
        successColor
        warningColor
        errorColor
        additionalInstructions
        defaultIdentityPackId
        updatedBy
        themes
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getOrganizationAIContextAssetUploadUrl = /* GraphQL */ `
  query GetOrganizationAIContextAssetUploadUrl(
    $query: GetOrganizationAIContextAssetUploadUrlInput!
  ) {
    getOrganizationAIContextAssetUploadUrl(query: $query) {
      uploadUrl
      s3Key
    }
  }
`;
export const getOrganizationAIContextAssetUrl = /* GraphQL */ `
  query GetOrganizationAIContextAssetUrl($query: GetOrganizationAIContextAssetUrlInput!) {
    getOrganizationAIContextAssetUrl(query: $query) {
      url
    }
  }
`;
export const getDashboardAttachmentUploadUrl = /* GraphQL */ `
  query GetDashboardAttachmentUploadUrl($query: GetDashboardAttachmentUploadUrlInput!) {
    getDashboardAttachmentUploadUrl(query: $query) {
      url
      s3Key
      contentType
    }
  }
`;
export const getWorkspace = /* GraphQL */ `
  query GetWorkspace($id: ID!) {
    getWorkspace(id: $id) {
      id
      name
      seq
      homeDashboardId
      avatarColor
      avatarIcon
      avatarEmoji
      avatarInitials
      organization {
        id
        name
        color
        workspaceLimit
        warehouseRetention
        timezone
        maintenanceWindow
        slug
        cloudResourceId
        wholeSourceConfig
        wholeSourceConfigVersion
        terraformConfig
        terraformConfigVersion
      }
      users {
        items {
          user {
            id
            email
            firstName
            lastName
            isActive
          }
          role
        }
        nextToken
      }
    }
  }
`;
export const listWorkspacesByOrganization = /* GraphQL */ `
  query ListWorkspacesByOrganization(
    $organizationId: ID
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelWorkspaceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listWorkspacesByOrganization(
      organizationId: $organizationId
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        seq
        homeDashboardId
        avatarColor
        avatarIcon
        avatarEmoji
        avatarInitials
        organization {
          id
          name
          color
          workspaceLimit
          warehouseRetention
          timezone
          maintenanceWindow
          slug
          cloudResourceId
          wholeSourceConfig
          wholeSourceConfigVersion
          terraformConfig
          terraformConfigVersion
        }
      }
      nextToken
    }
  }
`;
export const listWorkspaceUsersByUser = /* GraphQL */ `
  query ListWorkspaceUsersByUser(
    $userId: ID
    $workspaceId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelWorkspaceUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listWorkspaceUsersByUser(
      userId: $userId
      workspaceId: $workspaceId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        user {
          id
          email
          firstName
          lastName
          isActive
        }
        workspace {
          id
          name
          seq
          homeDashboardId
          avatarColor
          avatarIcon
          avatarEmoji
          avatarInitials
          organization {
            id
            name
            color
            workspaceLimit
            warehouseRetention
            timezone
            maintenanceWindow
            slug
            cloudResourceId
            wholeSourceConfig
            wholeSourceConfigVersion
            terraformConfig
            terraformConfigVersion
            workspaces {
              items {
                id
                name
              }
            }
          }
        }
        role
      }
      nextToken
    }
  }
`;
export const getSource = /* GraphQL */ `
  query GetSource($id: ID!) {
    getSource(id: $id) {
      id
      name
      description
      connectionId
      workspaceId
      cloudResourceId
      connection {
        isPaused
        createdAt
        pausedAt
      }
    }
  }
`;
export const listSourcesByWorkspace = /* GraphQL */ `
  query ListSourcesByWorkspace(
    $workspaceId: ID
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSourceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSourcesByWorkspace(
      workspaceId: $workspaceId
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        connectionId
        connection {
          isPaused
          createdAt
          pausedAt
        }
        workspaceId
        cloudResourceId
      }
      nextToken
    }
  }
`;
export const listSourcesByConnection = /* GraphQL */ `
  query ListSourcesByConnection(
    $connectionId: ID
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSourceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSourcesByConnection(
      connectionId: $connectionId
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
      }
      nextToken
    }
  }
`;
export const listSourcesByCloudResourceId = /* GraphQL */ `
  query ListSourcesByCloudResourceId(
    $cloudResourceId: String
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSourceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSourcesByCloudResourceId(
      cloudResourceId: $cloudResourceId
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
      }
      nextToken
    }
  }
`;
export const listSourceWorkspaceSharesBySource = /* GraphQL */ `
  query ListSourceWorkspaceSharesBySource(
    $sourceId: ID
    $workspaceId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSourceWorkspaceShareFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSourceWorkspaceSharesBySource(
      sourceId: $sourceId
      workspaceId: $workspaceId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        workspaceId
      }
      nextToken
    }
  }
`;
export const listSourceWorkspaceSharesByWorkspace = /* GraphQL */ `
  query ListSourceWorkspaceSharesByWorkspace(
    $workspaceId: ID
    $sourceId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelSourceWorkspaceShareFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSourceWorkspaceSharesByWorkspace(
      workspaceId: $workspaceId
      sourceId: $sourceId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        source {
          id
          name
          description
          connectionId
          workspaceId
          cloudResourceId
          connection {
            isPaused
            createdAt
            pausedAt
          }
        }
      }
      nextToken
    }
  }
`;
export const getDataObject = /* GraphQL */ `
  query GetDataObject($id: ID!) {
    getDataObject(id: $id) {
      id
      name
      viewName
      sourceId
      source {
        workspace {
          seq
        }
      }
      cloudResourceId
      cloudResourceInfo
    }
  }
`;
export const listDataObjectsBySource = /* GraphQL */ `
  query ListDataObjectsBySource(
    $sourceId: ID
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDataObjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDataObjectsBySource(
      sourceId: $sourceId
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        viewName
        sourceId
        source {
          workspace {
            seq
          }
        }
        cloudResourceId
        cloudResourceInfo
      }
      nextToken
    }
  }
`;
export const listDataObjectsByViewName = /* GraphQL */ `
  query ListDataObjectsByViewName(
    $viewName: String
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDataObjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDataObjectsByViewName(
      viewName: $viewName
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        viewName
        sourceId
        source {
          workspace {
            seq
          }
        }
        cloudResourceId
        cloudResourceInfo
      }
      nextToken
    }
  }
`;
export const getDataset = /* GraphQL */ `
  query GetDataset($id: ID!) {
    getDataset(id: $id) {
      id
      ownerId
      owner {
        id
        email
        firstName
        lastName
        isActive
      }
      name
      description
      enableSearchByAI
      sourceConversationId
      retentionOverride
      viewName
      isDraft
      folderId
      trigger
      triggerDetails
      vizCount
      totalSize
      latestVersionSize
      workspaceId
      workspace {
        seq
        organizationId
      }
      cloudResourceId
      cloudResourceInfo
      lastRunStatus
    }
  }
`;
export const getDatasetOnlySharedWithWorkspaceIds = /* GraphQL */ `
  query GetDatasetOnlySharedWithWorkspaceIds($id: ID!) {
    getDataset(id: $id) {
      sharedWithWorkspaceIds
    }
  }
`;
export const listDatasetsByFolder = /* GraphQL */ `
  query ListDatasetsByFolder(
    $folderId: ID
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDatasetFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDatasetsByFolder(
      folderId: $folderId
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        ownerId
        owner {
          id
          email
          firstName
          lastName
          isActive
        }
        name
        description
        enableSearchByAI
        retentionOverride
        viewName
        isDraft
        folderId
        trigger
        triggerDetails
        vizCount
        totalSize
        latestVersionSize
        workspaceId
        workspace {
          seq
          organizationId
        }
        cloudResourceId
        cloudResourceInfo
        lastRunStatus
      }
      nextToken
    }
  }
`;
export const listDatasetsByViewName = /* GraphQL */ `
  query ListDatasetsByViewName(
    $viewName: String
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDatasetFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDatasetsByViewName(
      viewName: $viewName
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        ownerId
        owner {
          id
          email
          firstName
          lastName
          isActive
        }
        name
        description
        enableSearchByAI
        retentionOverride
        viewName
        isDraft
        folderId
        trigger
        triggerDetails
        vizCount
        totalSize
        latestVersionSize
        workspaceId
        workspace {
          seq
          organizationId
        }
        cloudResourceId
        cloudResourceInfo
      }
      nextToken
    }
  }
`;
export const listDatasetsByWorkspace = /* GraphQL */ `
  query ListDatasetsByWorkspace(
    $workspaceId: ID
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDatasetFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDatasetsByWorkspace(
      workspaceId: $workspaceId
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        ownerId
        owner {
          id
          email
          firstName
          lastName
          isActive
        }
        name
        description
        enableSearchByAI
        retentionOverride
        viewName
        isDraft
        folderId
        trigger
        triggerDetails
        vizCount
        totalSize
        latestVersionSize
        workspaceId
        workspace {
          seq
          organizationId
        }
        cloudResourceId
        cloudResourceInfo
      }
      nextToken
    }
  }
`;
export const listDatasetsByWorkspaceOnlyIdAndName = /* GraphQL */ `
  query ListDatasetsByWorkspaceOnlyIdAndName(
    $workspaceId: ID
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDatasetFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDatasetsByWorkspace(
      workspaceId: $workspaceId
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
      }
      nextToken
    }
  }
`;
export const getDatasetTest = /* GraphQL */ `
  query GetDatasetTest($id: ID!) {
    getDatasetTest(id: $id) {
      id
      datasetId
      ownerId
      name
      isDraft
      workspaceId
      cloudResourceId
      cloudResourceInfo
    }
  }
`;
export const listDatasetTestsByDataset = /* GraphQL */ `
  query ListDatasetTestsByDataset(
    $datasetId: ID
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDatasetTestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDatasetTestsByDataset(
      datasetId: $datasetId
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        datasetId
        ownerId
        name
        isDraft
        workspaceId
        cloudResourceId
        cloudResourceInfo
      }
    }
  }
`;
export const getDatasetShareFromWorkspaceWithWorkspaceLink = /* GraphQL */ `
  query GetDatasetShareFromWorkspaceWithWorkspaceLink($id: ID!) {
    getDatasetShareFromWorkspaceWithWorkspaceLink(id: $id) {
      id
    }
  }
`;
export const listDatasetShareFromWorkspaceWithWorkspaceLinksByWithWorkspaceId = /* GraphQL */ `
  query ListDatasetShareFromWorkspaceWithWorkspaceLinksByWithWorkspaceId(
    $withWorkspaceId: ID
    $fromWorkspaceId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDatasetShareFromWorkspaceWithWorkspaceLinkFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDatasetShareFromWorkspaceWithWorkspaceLinksByWithWorkspaceId(
      withWorkspaceId: $withWorkspaceId
      fromWorkspaceId: $fromWorkspaceId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        fromWorkspace {
          id
          name
          avatarColor
          avatarIcon
          avatarEmoji
          avatarInitials
        }
      }
      nextToken
    }
  }
`;
export const listDatasetWorkspaceSharesByDataset = /* GraphQL */ `
  query ListDatasetWorkspaceSharesByDataset(
    $datasetId: ID
    $workspaceId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDatasetWorkspaceShareFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDatasetWorkspaceSharesByDataset(
      datasetId: $datasetId
      workspaceId: $workspaceId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        workspaceId
      }
      nextToken
    }
  }
`;
export const listDatasetWorkspaceSharesByWorkspaceAndOriginWorkspace = /* GraphQL */ `
  query ListDatasetWorkspaceSharesByWorkspaceAndOriginWorkspace(
    $workspaceId: ID
    $originWorkspaceId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDatasetWorkspaceShareFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDatasetWorkspaceSharesByWorkspaceAndOriginWorkspace(
      workspaceId: $workspaceId
      originWorkspaceId: $originWorkspaceId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        dataset {
          id
          ownerId
          owner {
            id
            email
            firstName
            lastName
            isActive
          }
          name
          viewName
          isDraft
          folderId
          trigger
          triggerDetails
          workspaceId
          workspace {
            seq
            organizationId
          }
          cloudResourceId
          cloudResourceInfo
        }
      }
      nextToken
    }
  }
`;
export const listDatasetWorkspaceSharesByWorkspaceAndOriginWorkspaceOnlyIds = /* GraphQL */ `
  query ListDatasetWorkspaceSharesByWorkspaceAndOriginWorkspaceOnlyIds(
    $workspaceId: ID
    $originWorkspaceId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDatasetWorkspaceShareFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDatasetWorkspaceSharesByWorkspaceAndOriginWorkspace(
      workspaceId: $workspaceId
      originWorkspaceId: $originWorkspaceId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        datasetId
        workspaceId
      }
      nextToken
    }
  }
`;
export const getFlow = /* GraphQL */ `
  query GetFlow($id: ID!) {
    getFlow(id: $id) {
      id
      name
      enabled
      trigger
      triggerDetails
      workspaceId
      createdAt
      datasetId
      dataset {
        name
      }
      destinationId
      destination {
        integration {
          name
        }
      }
      cloudResourceId
      cloudResourceInfo
    }
  }
`;
export const listFlowsByWorkspace = /* GraphQL */ `
  query ListFlowsByWorkspace(
    $workspaceId: ID
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFlowFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFlowsByWorkspace(
      workspaceId: $workspaceId
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        enabled
        trigger
        triggerDetails
        workspaceId
        createdAt
        datasetId
        dataset {
          name
        }
        destinationId
        destination {
          integration {
            name
          }
        }
        cloudResourceId
        cloudResourceInfo
      }
      nextToken
    }
  }
`;
export const getIntegration = /* GraphQL */ `
  query GetIntegration($id: ID!) {
    getIntegration(id: $id) {
      id
      name
      type
      category
      description
      dataSourceSupport
      flowActions
      createdAt
    }
  }
`;
export const listIntegrations = /* GraphQL */ `
  query ListIntegrations($filter: ModelIntegrationFilterInput, $limit: Int, $nextToken: String) {
    listIntegrations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        type
        category
        description
        dataSourceSupport
        flowActions
        createdAt
      }
      nextToken
    }
  }
`;
export const getConnectionOnlyNative = /* GraphQL */ `
  query GetConnectionOnlyNative($id: ID!) {
    getConnection(id: $id) {
      id
      name
      organizationId
      workspaceId
      isPaused
      pausedAt
      createdAt
      owner {
        id
        email
        firstName
        lastName
        isActive
      }
      integration {
        id
        name
        type
        category
        description
        dataSourceSupport
        flowActions
        createdAt
      }
      credentialsId
    }
  }
`;
export const getConnectionOnlyFivetran = /* GraphQL */ `
  query GetConnectionOnlyFivetran($id: ID!) {
    getConnection(id: $id) {
      id
      name
      organizationId
      workspaceId
      owner {
        id
        email
        firstName
        lastName
        isActive
      }
      fivetranConnection {
        id
        name
        serviceName
        glueDatabaseName
        integrationName
        isDeployed
      }
    }
  }
`;
export const listConnectionsByWorkspaceNative = /* GraphQL */ `
  query ListConnectionsByWorkspaceNative(
    $workspaceId: ID
    $integrationId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelConnectionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listConnectionsByWorkspaceNative(
      workspaceId: $workspaceId
      integrationId: $integrationId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        organizationId
        workspaceId
        isPaused
        pausedAt
        createdAt
        owner {
          id
          email
          firstName
          lastName
          isActive
        }
        integration {
          id
          name
          type
          category
          description
          dataSourceSupport
          flowActions
          createdAt
        }
        credentialsId
      }
      nextToken
    }
  }
`;
export const listConnectionsByWorkspaceFivetran = /* GraphQL */ `
  query ListConnectionsByWorkspaceFivetran(
    $workspaceId: ID
    $fivetranConnectionId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelConnectionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listConnectionsByWorkspaceFivetran(
      workspaceId: $workspaceId
      fivetranConnectionId: $fivetranConnectionId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        organizationId
        workspaceId
        isPaused
        pausedAt
        createdAt
        owner {
          id
          email
          firstName
          lastName
          isActive
        }
        fivetranConnection {
          id
          name
          serviceName
          glueDatabaseName
          integrationName
          isDeployed
        }
      }
      nextToken
    }
  }
`;
export const listConnectionsByOrganizationFivetran = /* GraphQL */ `
  query ListConnectionsByOrganizationFivetran(
    $organizationId: ID
    $fivetranConnectionId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelConnectionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listConnectionsByOrganizationFivetran(
      organizationId: $organizationId
      fivetranConnectionId: $fivetranConnectionId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        organizationId
        workspaceId
        owner {
          id
          email
          firstName
          lastName
          isActive
        }
        fivetranConnection {
          id
          name
          serviceName
          glueDatabaseName
          integrationName
          isDeployed
        }
      }
      nextToken
    }
  }
`;
export const listConnectionsByOrganizationNative = /* GraphQL */ `
  query ListConnectionsByOrganizationNative(
    $organizationId: ID
    $integrationId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelConnectionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listConnectionsByOrganizationNative(
      organizationId: $organizationId
      integrationId: $integrationId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        organizationId
        workspaceId
        owner {
          id
          email
          firstName
          lastName
          isActive
        }
        integration {
          id
          name
          type
          category
          description
          dataSourceSupport
          flowActions
          createdAt
        }
        credentialsId
      }
      nextToken
    }
  }
`;
export const listConnectionsByOrganizationNativeOnlyIdAndName = /* GraphQL */ `
  query ListConnectionsByOrganizationNativeOnlyIdAndName(
    $organizationId: ID
    $integrationId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelConnectionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listConnectionsByOrganizationNative(
      organizationId: $organizationId
      integrationId: $integrationId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        integration {
          name
        }
      }
      nextToken
    }
  }
`;
export const listConnectionsByFivetranConnection = /* GraphQL */ `
  query ListConnectionsByFivetranConnection(
    $fivetranConnectionId: ID
    $organizationId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelConnectionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listConnectionsByFivetranConnection(
      fivetranConnectionId: $fivetranConnectionId
      organizationId: $organizationId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
      }
      nextToken
    }
  }
`;
export const getFivetranConnection = /* GraphQL */ `
  query GetFivetranConnection($id: ID!) {
    getFivetranConnection(id: $id) {
      id
      name
      serviceName
      glueDatabaseName
      integrationName
      isDeployed
    }
  }
`;
export const getCredentials = /* GraphQL */ `
  query GetCredentials($id: ID!) {
    getCredentials(id: $id) {
      id
      username
      password
    }
  }
`;
export const getFolder = /* GraphQL */ `
  query GetFolder($id: ID!) {
    getFolder(id: $id) {
      id
      name
      parentId
      parent {
        id
        name
      }
      subFolders {
        items {
          id
          name
        }
        nextToken
      }
      datasets {
        items {
          id
          name
        }
        nextToken
      }
    }
  }
`;
export const listFoldersByParent = /* GraphQL */ `
  query ListFoldersByParent(
    $parentId: ID
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFolderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFoldersByParent(
      parentId: $parentId
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        parentId
        createdAt
        parent {
          id
          name
        }
      }
      nextToken
    }
  }
`;
export const getDownload = /* GraphQL */ `
  query GetDownload($id: ID!) {
    getDownload(id: $id) {
      id
      dataId
      dataTimeStamp
      requesterId
      requester {
        id
        email
        firstName
        lastName
        isActive
      }
      requestTimeStamp
      signedDownloadUrl
    }
  }
`;
export const listDownloadsByData = /* GraphQL */ `
  query ListDownloadsByData(
    $dataId: ID
    $dataTimeStamp: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDownloadFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDownloadsByData(
      dataId: $dataId
      dataTimeStamp: $dataTimeStamp
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        dataId
        dataTimeStamp
        requesterId
        requester {
          id
          email
          firstName
          lastName
          isActive
        }
        requestTimeStamp
        signedDownloadUrl
      }
      nextToken
    }
  }
`;
export const sqlQueriesByDataset = /* GraphQL */ `
  query SqlQueriesByDataset(
    $datasetId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDatasetSqlQueryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    sqlQueriesByDataset(
      datasetId: $datasetId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        datasetId
        workspaceId
        sqlQuery
        trigger
        triggerDetails
        deployed
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getDatasetVisualization = /* GraphQL */ `
  query GetDatasetVisualization($id: ID!) {
    getDatasetVisualization(id: $id) {
      id
      datasetId
      workspaceId
      name
      type
      configurations
      createdAt
      updatedAt
    }
  }
`;
export const visualizationsByDataset = /* GraphQL */ `
  query VisualizationsByDataset(
    $datasetId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDatasetVisualizationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    visualizationsByDataset(
      datasetId: $datasetId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        datasetId
        workspaceId
        name
        type
        configurations
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const listVisualizationsByWorkspace = /* GraphQL */ `
  query ListVisualizationsByWorkspace(
    $workspaceId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDatasetVisualizationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listVisualizationsByWorkspace(
      workspaceId: $workspaceId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        datasetId
        dataset {
          name
        }
        workspaceId
        name
        type
        configurations
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const pipelineResultsByRecordCloudResourceId = /* GraphQL */ `
  query PipelineResultsByRecordCloudResourceId(
    $recordCloudResourceId: String
    $timestamp: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelPipelineResultFilterInput
    $limit: Int
    $nextToken: String
  ) {
    pipelineResultsByRecordCloudResourceId(
      recordCloudResourceId: $recordCloudResourceId
      timestamp: $timestamp
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        recordCloudResourceId
        timestamp
        status
        info
      }
      nextToken
    }
  }
`;
export const listEventsByWorkspace = /* GraphQL */ `
  query ListEventsByWorkspace(
    $actionSourceWorkspaceId: ID
    $actionRecordedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEventsByWorkspace(
      actionSourceWorkspaceId: $actionSourceWorkspaceId
      actionRecordedAt: $actionRecordedAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        message
        level
        userId
        actionType
        actionSourceId
        actionSourceName
        actionSourceType
        actionSourceWorkspaceId
        actionData
        actionRecordedAt
        createdAt
      }
      nextToken
    }
  }
`;
export const beemAgentGetDataObjectContent = /* GraphQL */ `
  query BeemAgentGetDataObjectContent($query: GetDataObjectContentQueryInput) {
    beemAgentGetDataObjectContent(query: $query) {
      executionId
    }
  }
`;
export const beemAgentGetDatasetInfo = /* GraphQL */ `
  query BeemAgentGetDatasetInfo($query: GetDatasetInfoQueryInput) {
    beemAgentGetDatasetInfo(query: $query) {
      info
    }
  }
`;
export const beemAgentGetDatasetContentSync = /* GraphQL */ `
  query BeemAgentGetDatasetContentSync($query: GetDatasetContentQueryInput) {
    beemAgentGetDatasetContentSync(query: $query) {
      rows
    }
  }
`;
export const beemAgentGetDatasetContent = /* GraphQL */ `
  query BeemAgentGetDatasetContent($query: GetDatasetContentQueryInput) {
    beemAgentGetDatasetContent(query: $query) {
      executionId
    }
  }
`;
export const beemAgentGetDatasetConsolidatedTestResults = /* GraphQL */ `
  query BeemAgentGetDatasetConsolidatedTestResults(
    $query: GetDatasetConsolidatedTestResultsQueryInput
  ) {
    beemAgentGetDatasetConsolidatedTestResults(query: $query) {
      executionId
    }
  }
`;
export const beemAgentModifyDataset = /* GraphQL */ `
  query BeemAgentModifyDataset($query: ModifyDatasetQueryInput) {
    beemAgentModifyDataset(query: $query) {
      dummy
    }
  }
`;
export const beemAgentDeleteDatasetHistoricalData = /* GraphQL */ `
  query BeemAgentDeleteDatasetHistoricalData($query: DeleteDatasetHistoricalDataQueryInput) {
    beemAgentDeleteDatasetHistoricalData(query: $query) {
      dummy
    }
  }
`;
export const beemAgentGetFlowInfo = /* GraphQL */ `
  query BeemAgentGetFlowInfo($query: GetFlowInfoQueryInput) {
    beemAgentGetFlowInfo(query: $query) {
      info
    }
  }
`;
export const beemAgentCheckRedshiftQuery = /* GraphQL */ `
  query BeemAgentCheckRedshiftQuery($query: CheckRedshiftQueryInput) {
    beemAgentCheckRedshiftQuery(query: $query) {
      status
      cols
      rows
      error
    }
  }
`;
export const beemAgentCancelRedshiftQuery = /* GraphQL */ `
  query BeemAgentCancelRedshiftQuery($query: CancelRedshiftQueryInput) {
    beemAgentCancelRedshiftQuery(query: $query) {
      status
    }
  }
`;
export const beemAgentInsightConverse = /* GraphQL */ `
  query BeemAgentInsightConverse($query: InsightConverseInput) {
    beemAgentInsightConverse(query: $query) {
      messages
      metadata
      reasoning
    }
  }
`;
// Asynchronous insights turns (BEEM-1448): start returns at once, the answer arrives through
// onUpdateInsightTurn (see subscriptions.ts), and the conversation is read once the turn is DONE.
export const beemAgentStartInsightConverse = /* GraphQL */ `
  query BeemAgentStartInsightConverse($query: StartInsightConverseInput) {
    beemAgentStartInsightConverse(query: $query) {
      id
    }
  }
`;
export const beemAgentCancelInsightTurn = /* GraphQL */ `
  query BeemAgentCancelInsightTurn($query: InsightTurnIdInput) {
    beemAgentCancelInsightTurn(query: $query) {
      id
      status
    }
  }
`;
export const beemAgentGetInsightTurnMessages = /* GraphQL */ `
  query BeemAgentGetInsightTurnMessages($query: InsightTurnIdInput) {
    beemAgentGetInsightTurnMessages(query: $query) {
      messages
    }
  }
`;
// Just a dashboard's progress, for a chat card that follows a dashboard being built (getById
// resolves every artifact, too heavy to poll). "Only" is what makes graphql() read the
// "getGenerativeDashboard" root field: named without it, every read came back undefined and the
// card never left "Building" (BEEM-2362).
export const getGenerativeDashboardOnlyStatus = /* GraphQL */ `
  query GetGenerativeDashboardOnlyStatus($id: ID!) {
    getGenerativeDashboard(id: $id) {
      id
      status
      progressStep
    }
  }
`;
export const getInsightTurn = /* GraphQL */ `
  query GetInsightTurn($id: ID!) {
    getInsightTurn(id: $id) {
      id
      userId
      workspaceId
      sessionId
      status
      answerText
      reasoningText
      steps
      memoryCount
      error
      ttl
      createdAt
      updatedAt
    }
  }
`;
export const beemAgentInsightMemories = /* GraphQL */ `
  query BeemAgentInsightMemories($query: InsightMemoriesInput) {
    beemAgentInsightMemories(query: $query) {
      enabled
      memories {
        id
        text
        kind
        namespaces
        createdAt
        userAuthored
      }
      nextToken
    }
  }
`;
export const beemAgentManageInsightMemory = /* GraphQL */ `
  query BeemAgentManageInsightMemory($query: ManageInsightMemoryInput) {
    beemAgentManageInsightMemory(query: $query) {
      enabled
      memory {
        id
        text
        kind
        namespaces
        createdAt
        userAuthored
      }
    }
  }
`;
export const beemAgentReportInsightFeedback = /* GraphQL */ `
  query BeemAgentReportInsightFeedback($query: ReportInsightFeedbackInput) {
    beemAgentReportInsightFeedback(query: $query) {
      ticketId
    }
  }
`;
export const beemAgentStartIngestion = /* GraphQL */ `
  query BeemAgentStartIngestion($query: StartIngestionQueryInput) {
    beemAgentStartIngestion(query: $query) {
      success
    }
  }
`;
export const beemAgentCheckSourceSyncStatus = /* GraphQL */ `
  query BeemAgentCheckSourceSyncStatus($query: CheckSourceSyncStatusQueryInput) {
    beemAgentCheckSourceSyncStatus(query: $query) {
      step2Complete
      step2Failed
    }
  }
`;
export const beemAgentPreviewDatasetQuery = /* GraphQL */ `
  query BeemAgentPreviewDatasetQuery($query: PreviewDatasetQueryQueryInput) {
    beemAgentPreviewDatasetQuery(query: $query) {
      executionId
      fromCache
      stale
      createdAt
      cols
      rows
      cacheContext
    }
  }
`;
export const beemAgentSetDashboardCacheConfig = /* GraphQL */ `
  query BeemAgentSetDashboardCacheConfig($query: SetDashboardCacheConfigInput) {
    beemAgentSetDashboardCacheConfig(query: $query) {
      success
    }
  }
`;
export const beemAgentNotifyVizDeleted = /* GraphQL */ `
  query BeemAgentNotifyVizDeleted($query: NotifyVizDeletedInput) {
    beemAgentNotifyVizDeleted(query: $query) {
      success
    }
  }
`;
export const beemAgentNotifyVizRemovedFromDashboard = /* GraphQL */ `
  query BeemAgentNotifyVizRemovedFromDashboard($query: NotifyVizRemovedFromDashboardInput) {
    beemAgentNotifyVizRemovedFromDashboard(query: $query) {
      success
    }
  }
`;
export const beemAgentStartUnload = /* GraphQL */ `
  query BeemAgentStartUnload($query: StartUnloadQueryInput) {
    beemAgentStartUnload(query: $query) {
      executionId
      checkUnloadProps
    }
  }
`;
export const beemAgentCheckUnload = /* GraphQL */ `
  query BeemAgentCheckUnload($query: CheckUnloadQueryInput) {
    beemAgentCheckUnload(query: $query) {
      isStillRunning
    }
  }
`;
export const fivetranFetchConnections = /* GraphQL */ `
  query FivetranFetchConnections($query: FivetranFetchConnectionsInput) {
    fivetranFetchConnections(query: $query) {
      response
    }
  }
`;
export const refreshDataset = /* GraphQL */ `
  query RefreshDataset($query: RefreshDatasetQueryInput) {
    refreshDataset(query: $query) {
      success
    }
  }
`;
export const validateIntegrationCredentials = /* GraphQL */ `
  query ValidateIntegrationCredentials($query: ValidateIntegrationCredentialsQueryInput) {
    validateIntegrationCredentials(query: $query)
  }
`;
export const updateOrganizationSettings = /* GraphQL */ `
  query UpdateOrganizationSettings($query: UpdateOrganizationSettingsInput) {
    updateOrganizationSettings(query: $query) {
      success
    }
  }
`;
export const getWarehouseStorageInfo = /* GraphQL */ `
  query GetWarehouseStorageInfo($query: GetWarehouseStorageInfoInput) {
    getWarehouseStorageInfo(query: $query) {
      totalStorageCapacityInMegaBytes
      totalStorageUsedInMegaBytes
    }
  }
`;
export const getBillingSummary = /* GraphQL */ `
  query GetBillingSummary($query: GetBillingSummaryInput) {
    getBillingSummary(query: $query) {
      planId
      planName
      subscriptionStatus
      currencyCode
      billingPeriod
      billingPeriodUnit
      nextBillingAt
      invoices {
        id
        date
        status
        totalMinorUnits
        total
        currencyCode
      }
    }
  }
`;
export const getInvoiceDownloadUrl = /* GraphQL */ `
  query GetInvoiceDownloadUrl($query: GetInvoiceDownloadUrlInput) {
    getInvoiceDownloadUrl(query: $query) {
      downloadUrl
      validTill
    }
  }
`;
export const getWarehouseConnectionInfo = /* GraphQL */ `
  query GetWarehouseConnectionInfo($query: GetWarehouseConnectionInfoInput) {
    getWarehouseConnectionInfo(query: $query) {
      host
      port
      database
    }
  }
`;
export const configureNewWorkspaceInTheWarehouse = /* GraphQL */ `
  query ConfigureNewWorkspaceInTheWarehouse($query: ConfigureNewWorkspaceInTheWarehouseInput) {
    configureNewWorkspaceInTheWarehouse(query: $query) {
      success
    }
  }
`;
export const upsertUserWarehouseCredentials = /* GraphQL */ `
  query UpsertUserWarehouseCredentials($query: UpsertUserWarehouseCredentialsInput) {
    upsertUserWarehouseCredentials(query: $query) {
      password
    }
  }
`;
export const createCognitoUser = /* GraphQL */ `
  query CreateCognitoUser($query: CreateCognitoUserInput) {
    createCognitoUser(query: $query) {
      id
    }
  }
`;
export const fivetranCreateConnectCard = /* GraphQL */ `
  query FivetranCreateConnectCard($query: FivetranCreateConnectCardInput) {
    fivetranCreateConnectCard(query: $query) {
      response
    }
  }
`;

export const fivetranRecreateConnectCard = /* GraphQL */ `
  query FivetranRecreateConnectCard($query: FivetranRecreateConnectCardInput) {
    fivetranRecreateConnectCard(query: $query) {
      response
    }
  }
`;
export const beemAgentFivetranDeployConnector = /* GraphQL */ `
  query BeemAgentFivetranDeployConnector($query: FivetranDeployConnectorQueryInput) {
    beemAgentFivetranDeployConnector(query: $query) {
      dummy
    }
  }
`;
export const beemAgentFivetranUndeployConnector = /* GraphQL */ `
  query BeemAgentFivetranUndeployConnector($query: FivetranUndeployConnectorQueryInput) {
    beemAgentFivetranUndeployConnector(query: $query) {
      dummy
    }
  }
`;
export const beemAgentDeleteOAuthCredentials = /* GraphQL */ `
  query BeemAgentDeleteOAuthCredentials($query: DeleteOAuthCredentialsQueryInput) {
    beemAgentDeleteOAuthCredentials(query: $query) {
      dummy
    }
  }
`;
export const beemAgentAdminLogoutUser = /* GraphQL */ `
  query BeemAgentAdminLogoutUser($query: AdminLogoutUserInput) {
    beemAgentAdminLogoutUser(query: $query) {
      dummy
    }
  }
`;
export const fivetranCheckInitialSyncStatus = /* GraphQL */ `
  query FivetranCheckInitialSyncStatus($query: FivetranCheckInitialSyncStatusInput) {
    fivetranCheckInitialSyncStatus(query: $query)
  }
`;

export const fivetranSyncConnectorData = /* GraphQL */ `
  query FivetranSyncConnectorData($query: FivetranSyncConnectorDataInput) {
    fivetranSyncConnectorData(query: $query)
  }
`;

export const fivetranDeleteConnector = /* GraphQL */ `
  query FivetranDeleteConnector($query: FivetranDeleteConnectorInput) {
    fivetranDeleteConnector(query: $query) {
      code
      message
    }
  }
`;
export const fivetranUpdateConnector = /* GraphQL */ `
  query FivetranUpdateConnector($query: FivetranUpdateConnectorInput) {
    fivetranUpdateConnector(query: $query) {
      code
      message
    }
  }
`;
export const getIDatasetUser = /* GraphQL */ `
  query GetIDatasetUser($id: ID!) {
    getIDatasetUser(id: $id) {
      id
      datasetId
      userId
      options
    }
  }
`;
export const getDashboard = /* GraphQL */ `
  query GetDashboard($id: ID!) {
    getDashboard(id: $id) {
      id
      name
      workspaceId
      settings
      createdAt
      updatedAt
    }
  }
`;
export const listDashboardsByWorkspace = /* GraphQL */ `
  query ListDashboardsByWorkspace(
    $workspaceId: ID
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDashboardFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDashboardsByWorkspace(
      workspaceId: $workspaceId
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        workspaceId
        settings
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getDashboardWidget = /* GraphQL */ `
  query GetDashboardWidget($id: ID!) {
    getDashboardWidget(id: $id) {
      id
      dashboardId
      type
      componentId
      position
      workspaceId
      createdAt
      updatedAt
    }
  }
`;
export const listDashboardWidgetsByDashboard = /* GraphQL */ `
  query ListDashboardWidgetsByDashboard(
    $dashboardId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDashboardWidgetFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDashboardWidgetsByDashboard(
      dashboardId: $dashboardId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        dashboardId
        type
        componentId
        configurations
        position
        workspaceId
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getUserPreferenceDashboard = /* GraphQL */ `
  query GetUserPreferenceDashboard($id: ID!) {
    getUserPreferenceDashboard(id: $id) {
      id
      userId
      dashboardId
      options
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const auth0CreateUser = /* GraphQL */ `
  query Auth0CreateUser($query: Auth0CreateUserInput) {
    auth0CreateUser(query: $query) {
      id
    }
  }
`;
export const auth0ChangePassword = /* GraphQL */ `
  query Auth0ChangePassword($query: Auth0ChangePasswordInput) {
    auth0ChangePassword(query: $query) {
      dummy
    }
  }
`;
export const auth0UpdateUserMetadata = /* GraphQL */ `
  query Auth0UpdateUserMetadata($query: Auth0UpdateUserMetadataInput) {
    auth0UpdateUserMetadata(query: $query) {
      dummy
    }
  }
`;
export const getMetaAuthorizeUrl = /* GraphQL */ `
  query GetMetaAuthorizeUrl($query: MetaAuthorizeUrlInput) {
    getMetaAuthorizeUrl(query: $query) {
      url
    }
  }
`;
export const getZohoAuthorizeUrl = /* GraphQL */ `
  query GetZohoAuthorizeUrl($query: ZohoAuthorizeUrlInput) {
    getZohoAuthorizeUrl(query: $query) {
      url
    }
  }
`;
export const getLinkedInAuthorizeUrl = /* GraphQL */ `
  query GetLinkedInAuthorizeUrl($query: LinkedInAuthorizeUrlInput) {
    getLinkedInAuthorizeUrl(query: $query) {
      url
    }
  }
`;
export const getMicrosoftAuthorizeUrl = /* GraphQL */ `
  query GetMicrosoftAuthorizeUrl($query: MicrosoftAuthorizeUrlInput) {
    getMicrosoftAuthorizeUrl(query: $query) {
      url
    }
  }
`;
export const getGenerativeDashboard = /* GraphQL */ `
  query GetGenerativeDashboard($id: ID!) {
    getGenerativeDashboard(id: $id) {
      id
      name
      workspaceId
      prompt
      conversationHistory
      renderContent
      publishedRenderContent
      editVersions
      publishedVersions
      drilldownScript
      drilldownStatus
      wiringScript
      wiringPrelude
      cardWiringMap
      renderContentKey
      publishedRenderContentKey
      wiringScriptKey
      drilldownScriptKey
      wiringPreludeKey
      status
      errorMessage
      progressStep
      liveTrace
      generator
      sampleData
      buildTurnId
      sourceConversationId
      createdBy
      createdAt
      updatedAt
    }
  }
`;

export const listGenerativeDashboardsByWorkspace = /* GraphQL */ `
  query ListGenerativeDashboardsByWorkspace(
    $workspaceId: ID
    $name: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelGenerativeDashboardFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGenerativeDashboardsByWorkspace(
      workspaceId: $workspaceId
      name: $name
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        workspaceId
        status
        errorMessage
        createdBy
        createdAt
        updatedAt
        thumbnailKey
        thumbnailUpdatedAt
      }
      nextToken
    }
  }
`;

export const getGenerativeDashboardWidget = /* GraphQL */ `
  query GetGenerativeDashboardWidget($id: ID!) {
    getGenerativeDashboardWidget(id: $id) {
      id
      dashboardId
      workspaceId
      sqlQuery
      queryResult
      datasetIds
      widgetPrompt
      status
      createdAt
      updatedAt
    }
  }
`;

export const listGenerativeDashboardWidgetsByDashboard = /* GraphQL */ `
  query ListGenerativeDashboardWidgetsByDashboard(
    $dashboardId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelGenerativeDashboardWidgetFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGenerativeDashboardWidgetsByDashboard(
      dashboardId: $dashboardId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        dashboardId
        workspaceId
        sqlQuery
        queryResult
        datasetIds
        widgetPrompt
        status
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

// AI Insights conversations and projects, per user and workspace (BEEM-1448).
export const getInsightConversation = /* GraphQL */ `
  query GetInsightConversation($id: ID!) {
    getInsightConversation(id: $id) {
      id
      userId
      workspaceId
      title
      messages
      messageCount
      traces
      projectId
      originKey
      sessionId
      shared
      createdByName
      lastActivityAt
      createdAt
      updatedAt
    }
  }
`;
export const listInsightConversationsByUser = /* GraphQL */ `
  query ListInsightConversationsByUser(
    $userId: ID
    $workspaceId: ModelIDKeyConditionInput
    $limit: Int
    $nextToken: String
  ) {
    listInsightConversationsByUser(
      userId: $userId
      workspaceId: $workspaceId
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        userId
        workspaceId
        title
        messages
        messageCount
        traces
        projectId
        originKey
        sessionId
        shared
        createdByName
        lastActivityAt
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getInsightProject = /* GraphQL */ `
  query GetInsightProject($id: ID!) {
    getInsightProject(id: $id) {
      id
      ownerId
      workspaceId
      name
      description
      instructions
      knowledge
      datasetIds
      shared
      ownerName
      lastActivityAt
      createdAt
      updatedAt
    }
  }
`;
export const listInsightProjectsByOwner = /* GraphQL */ `
  query ListInsightProjectsByOwner(
    $ownerId: ID
    $workspaceId: ModelIDKeyConditionInput
    $limit: Int
    $nextToken: String
  ) {
    listInsightProjectsByOwner(
      ownerId: $ownerId
      workspaceId: $workspaceId
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        ownerId
        workspaceId
        name
        description
        instructions
        knowledge
        datasetIds
        shared
        ownerName
        lastActivityAt
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const beemAgentListSharedInsights = /* GraphQL */ `
  query BeemAgentListSharedInsights($query: ListSharedInsightsInput) {
    beemAgentListSharedInsights(query: $query) {
      conversations
      projects
    }
  }
`;
export const beemAgentGetSharedInsightConversation = /* GraphQL */ `
  query BeemAgentGetSharedInsightConversation($query: GetSharedInsightConversationInput) {
    beemAgentGetSharedInsightConversation(query: $query) {
      conversation
    }
  }
`;
export const beemAgentUpdateSharedInsightProject = /* GraphQL */ `
  query BeemAgentUpdateSharedInsightProject($query: UpdateSharedInsightProjectInput) {
    beemAgentUpdateSharedInsightProject(query: $query) {
      project
    }
  }
`;
